import { Action, Module, Mutation, VuexModule, getModule } from 'vuex-module-decorators'
import Vue from 'vue'
import store from '@app/componentlib/src/store'
import { IJobMatchProfile, IOCcupationToSave, IOccupation } from '@app/componentlib/common/types/JobMatchTypes'
import { apiUrl } from '@app/componentlib/src/application/helpers/api'
import { httpService } from '@app/componentlib/src/services/HttpService'
import { JobMatchModule } from '../JobMatch/jobMatch'
import { convertPropertyNames } from '@app/componentlib/src/application/helpers/convertPropNames'

const jobMatchApi = 'JobMatchApi'

@Module({
  dynamic: true,
  store,
  name: 'jobMatchOccupationData',
  namespaced: true
})

class jobMatchOccupationsh extends VuexModule {
  _occupations: IOccupation[] | undefined
  _selectedOccupations: IOccupation[] = []
  _addOccupations = false
  _gettingJobMatches = false

  @Action({ rawError: true })
  async getJobTitles (input: string) {
    if(this.gettingJobMatches === false && input !== null) {
      let lang = JobMatchModule.userInfo?.languageCode !== '' ? JobMatchModule.userInfo?.languageCode.slice(0,2) : 'en'
      console.log('FIND JOBTITLES, input is:', input)
      this.SET_GETTINGJOBMATCHES(true)
      const endpoint = 'JobDescriptionToOccupations'
      const noOfResults = 50
      const request = {
        JobDescription: input,
        ReturnLanguage: lang,
        NoOfResults: noOfResults
      }
      const reqUrl = apiUrl(jobMatchApi, endpoint)
      // Send the job goal to get a list of jobtitles
      await httpService.post(reqUrl, request).then((data: any) => {
        console.log('JOB MATCH GET JOBTITLES DATA:', data)
        if(data.Occupations) {
          // Convert Array to camelCase
          let occupations: IOccupation[] = data.Occupations.map((o: IOccupation) => {
            var temp = convertPropertyNames(o)
            if(this.selectedOccupations.find(s => s.label?.includes(temp.preferredLabel)))
              temp.isActive = true
            else
              temp.isActive = false
            return temp
          })

          this.setOccupations(occupations)
        }

        // Update user jobmatch Profile because use have update job description
        let profile: IJobMatchProfile = JobMatchModule.jobMatchProfile
        profile.currentJobDescription = input
        JobMatchModule.updateJobMatchProfile(profile)

        this.SET_GETTINGJOBMATCHES(false)
      })
    }
  }

  @Action({ rawError: true })
  async addOccupation(occupation: IOccupation) {
    // Check if the occupation is not already selected
    if (this.selectedOccupations.find(so => so.preferredLabel === occupation.preferredLabel) === undefined) {
      // Create a copy of selectedOccupations array or initialize an empty array if it's undefined
      const tempOccupations = this._selectedOccupations !== undefined ? [...this._selectedOccupations] : []
      // Add the new occupation to the temporary array
      tempOccupations.push(occupation)
      // Update the Vuex state by committing the new selectedOccupations array
      this.SET_SELECTED_OCCUPATIONS(tempOccupations)

      const newOccupation = {
        occupationCode: occupation.occupationCode,
        occupationSource: occupation.occupationSource,
        label: occupation.preferredLabel
      } as IOCcupationToSave

      // Check if the process of adding occupations is not already in progress
      if (this.addingOccupations === false) {
        this.SET_ADDOCCUPATIONS(true)

        try {
          const reqUrl = apiUrl(jobMatchApi, 'AddJobMatchProfileOccupations')

          // Send an HTTP POST request to the API to add the occupation
          await httpService.post(reqUrl, { CandidateId: null, Occupations: [newOccupation] }).then((data: any) => {
            console.log('ADD OCCUPATIONS: ', data)
            JobMatchModule.getJobMatchCount()
          })

          this.SET_ADDOCCUPATIONS(false)
        } catch (err) {
          console.warn('ERROR, ADD JOBMATCH PROFILE OCCUPATION: ', err)
          this.SET_ADDOCCUPATIONS(false)
        }
      }
    }
  }

  @Action({ rawError: true })
  async removeOccupation (occupation: IOccupation) {
    //Check if custom occupation
    let currentlySelected: boolean = false
    // Check if occupation is currently selected
    if (this.selectedOccupations?.find(occ => occ.preferredLabel === (occupation.preferredLabel))) currentlySelected = true
    // If occupationToRemove is true - we know its a custom occupation - find it in selected occupations list and remove it from it.
    let tempOccupations = this.selectedOccupations ? this.selectedOccupations.filter(so => (so.label || so.preferredLabel) !== (occupation.preferredLabel || occupation.label)) : []
    this.setSelectedOccupations(tempOccupations)
    const newOccupation = {
      occupationCode: occupation.occupationCode,
      occupationSource: occupation.occupationSource,
      label: occupation.preferredLabel || occupation.label
    } as IOCcupationToSave
    try {
      // This will completely delete the occupation from the selected and deselected lists.
      const reqUrl = apiUrl(jobMatchApi, 'RemoveJobMatchProfileOccupations')

      await httpService.delete(reqUrl, {CandidateId: null, Occupations: [newOccupation]}).then((data: any) => {
        console.log('DELETED OCCUPATIONS: ',  data)
        JobMatchModule.getJobMatchCount()
      })
    } catch (err) {
      console.warn('ERROR, ADD JOBMATCH PROFILE OCCUPATION: ', err)
    }
  }

  @Action({ rawError: true })
  async removeJobMatchProfileOccupations(occupation: IOccupation) {
    // This will completely delete the occupation from the selected and deselected lists.
    const reqUrl = apiUrl(jobMatchApi, 'RemoveJobMatchProfileOccupations')
    await httpService.delete(reqUrl, {CandidateId: null, Occupations: [occupation]}).then((data: any) => {
      console.log('DELETED OCCUPATIONS: ',  data)
      JobMatchModule.getJobMatchCount()
    })
  }

  @Action({ rawError: true })
  setOccupations(occupations: IOccupation[] | undefined) {
    if (occupations === undefined) return
    this.SET_OCCUPATIONS(occupations)
  }

  @Action({ rawError: true })
  setSelectedOccupations(occupations: IOccupation[] | undefined) {
    if (occupations === undefined) return
    this.SET_SELECTED_OCCUPATIONS(occupations)
  }

  @Action({ rawError: true })
  addOccupationsToSelectedOccupations (occupations: IOccupation[]) {
    let selectedOccupations: IOccupation[] = []
    occupations.map((o: IOccupation) => selectedOccupations.push(o))
    this.context.commit('SET_SELECTED_OCCUPATIONS', selectedOccupations)
  }

  // Mutations
  @Mutation
  SET_OCCUPATIONS (val: IOccupation[]) {
    Vue.set(this, '_occupations', val)
  }
  @Mutation
  SET_SELECTED_OCCUPATIONS (val: IOccupation[]) {
    Vue.set(this, '_selectedOccupations', val)
  }
  @Mutation
  SET_ADDOCCUPATIONS(bool: boolean) {
    Vue.set(this, '_addOccupations', bool)
  }
  @Mutation
  SET_GETTINGJOBMATCHES(bool: boolean) {
    Vue.set(this, '_gettingJobMatches', bool)
  }

  // Getters
  get occupations (): IOccupation[] | undefined {
    return this._occupations
  }
  get selectedOccupations (): IOccupation[] {
    return this._selectedOccupations
  }
  get addingOccupations (): boolean {
    return this._addOccupations
  }
  get gettingJobMatches (): boolean {
    return this._gettingJobMatches
  }
}

export const JobMatchOccupationModule = getModule(jobMatchOccupationsh)